var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHelpInfo = function SvgIconHelpInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 926"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 925",
    transform: "translate(-1144 -262)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#ff7900",
    "data-name": "Ellipse 89",
    transform: "translate(1144 262)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fe7921",
    d: "M1160 278h16v12a4 4 0 0 1-4 4h-12z",
    "data-name": "Rectangle 578"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "ProximaNova-Bold, Proxima Nova",
    fontSize: 20,
    fontWeight: 700,
    transform: "translate(14 23)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "i")))));
};
export default SvgIconHelpInfo;